/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Cancel_LabelInputs */



/**
* | output |
* | --- |
* | "Cancel sync" |
*
* @param {Team_Sync_Cancel_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_cancel_label = /** @type {((inputs?: Team_Sync_Cancel_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Cancel_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler la synchronisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierung abbrechen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla sincronizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить синхронизацию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar sincronización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消同步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期をキャンセル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक रद्द करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelar sincronização")
	return /** @type {LocalizedString} */ ("Cancel sync")
});